import { OTHERWORLD_BACKDROPS } from '../../../game/effects/atmosphere/silhouettes/otherworldBackdrops';
import { ATMOSPHERE_PALETTE as P } from '../palette';
import { volcanicBiome } from '../biomeArchetypes';

/** Volcanic — restless heat: ember motes, red heat-glow, heat-shimmer rays, a restless light
 *  bed, rising embers (fire→ash), heat flicker, and a multi-plane volcanic depth backdrop. */
export const VOLCANIC = volcanicBiome({
  id: 'volcanic',
  sky: { from: 0x1a0608, to: 0x6e2410 },
  motes: { colors: [P.ember, P.lava, P.amber] },
  rays: { color: P.ember },
  glow: {
    blobs: [
      { color: P.lava, atX: 0.5, atY: 0.96, size: 560, alpha: 0.14 },
      { color: P.ember, atX: 0.5, atY: 0.08, size: 420, alpha: 0.08 },
    ],
    breathe: { periodMs: 5200, min: 0.7, max: 1.35 },
  },
  lightField: { palette: [P.ember, P.lava, P.amber] },
  weather: { mode: 'rise', color: P.ember, colorEnd: 0x552211, size: 12, frequencyMs: 130, lifespanMs: 3600, speed: 34, gravityY: -18, windX: -22, alphaEnd: 0.6, gust: { periodMs: 7000, min: 0.55, max: 1.6, phase: 0.25 } },
  flicker: { color: P.lava },
  parallax: [
    { svg: OTHERWORLD_BACKDROPS.volcanic.far, shape: 'cone', color: 0x3a201a, speed: 0.04, height: 440, alpha: 0.72, detail: 0.8, sway: { ampPx: 14, periodMs: 26000 } },
    { svg: OTHERWORLD_BACKDROPS.volcanic.mid, shape: 'ridge', color: 0x241208, speed: 0.10, height: 300, alpha: 0.84, detail: 1.2 },
    { svg: OTHERWORLD_BACKDROPS.volcanic.near, shape: 'columns', color: 0x140a06, speed: 0.20, height: 180, alpha: 0.94, detail: 1 },
  ],
  closer: {
    vignette: { color: 0x1a0500, edgeAlpha: 0.32, washColor: 0xff5a1e, washAlpha: 0.05 },
    grade: { top: 0xff8a3c, bottom: 0x6e1f12, strength: 0.12, blend: 'add' },
  },
  // Heat haze — rippling hot-air shimmer near the ground (the lensing distortion
  // of heated air rising over the volcanic floor). Subtle: low alpha, warm ember
  // tint, scale pulse reads as shimmer. Placed via extraLayers (after flicker,
  // before parallax) so it sits behind the foreground silhouettes.
  extraLayers: [
    { kind: 'heatHaze', color: P.ember, count: 8, sizeMin: 180, sizeMax: 360,
      alphaMin: 0.04, alphaMax: 0.12, bandYMin: 0.75, bandYMax: 0.98,
      driftPx: 22, periodMinMs: 2500, periodMaxMs: 5000 },
  ],
});
